<template>
    <v-sheet
        class="d-flex flex-column flex-grow-1"
        style="height: 100%; min-height: 0"
    >
        <router-view v-slot="{ Component }">
            <component :is="Component" ref="routedView" />
        </router-view>
    </v-sheet>
</template>

<script>
export default {
    name: "MainLayout",
};
</script>
